/* ============================================================
   CHESTO PRODUCT CARD — minimal client-side glue
   Pair with snippets/card-product-chesto.liquid

   Responsibilities:
   • Toggle the favourite (heart) state and persist locally.
   • Hand the inline add-to-cart form off to Dawn's cart-notification
     / cart-drawer behaviour without navigating to /cart.

   Drop into theme.liquid:
     <script src="{{ 'component-chesto-card.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  if (window.__chestoCardInit) return;
  window.__chestoCardInit = true;

  const FAV_KEY = 'chesto:favs';
  const favs = new Set(JSON.parse(localStorage.getItem(FAV_KEY) || '[]'));

  function syncFavButton(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function init(root) {
    root.querySelectorAll('.chesto-card').forEach(card => {
      const id = card.dataset.productId;
      const fav = card.querySelector('[data-chesto-fav]');
      if (fav && id) {
        syncFavButton(fav, favs.has(id));
        fav.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          if (favs.has(id)) favs.delete(id);
          else favs.add(id);
          localStorage.setItem(FAV_KEY, JSON.stringify([...favs]));
          syncFavButton(fav, favs.has(id));
        });
      }

      // Stop link navigation when clicking interactive children
      card.querySelectorAll('button, .chesto-card__swatch, form').forEach(el => {
        el.addEventListener('click', e => e.stopPropagation());
      });

      // Inline add-to-cart — let Dawn's cart-notification handle the response
      card.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async e => {
          // If Dawn's cart-notification or cart-drawer custom element exists,
          // intercept and POST via fetch so the user never leaves the page.
          const notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (!notif) return; // fall back to native form submit
          e.preventDefault();
          const submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.classList.add('is-loading');
            submitBtn.disabled = true;
          }
          try {
            const body = new FormData(form);
            // Tell Shopify to return a JSON section so cart-notification can render it.
            if (notif.getSectionsToRender) {
              body.append('sections', notif.getSectionsToRender().map(s => s.id).join(','));
              body.append('sections_url', window.location.pathname);
            }
            const res = await fetch(`${window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body
            });
            const data = await res.json();
            if (res.ok) {
              if (notif.renderContents) notif.renderContents(data);
              if (submitBtn) {
                submitBtn.classList.add('is-added');
                setTimeout(() => submitBtn.classList.remove('is-added'), 1400);
              }
            } else if (data && data.description) {
              console.warn('[chesto-card] add-to-cart failed:', data.description);
            }
          } catch (err) {
            console.warn('[chesto-card] add-to-cart error:', err);
          } finally {
            if (submitBtn) {
              submitBtn.classList.remove('is-loading');
              submitBtn.disabled = false;
            }
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Re-init for any cards added later (e.g. ajax-loaded collection pages).
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
